export default __webpack_public_path__ + "static/media/Banner_02.c74b0656.png";